import React from 'react';

const withIndividualUserType =
	<T,>(Component: React.FC<T>) =>
	(props: T) =>
		<Component {...props} isTeamUser={false} />;

export default withIndividualUserType;
